/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-display-code',
    templateUrl: './displayCode.component.html',
    styleUrls: ['./displayCode.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DisplayCodeComponent implements OnInit {
    /**
     * Allow parent component to set the loading state.
     */
    @Input() public useInternalLoadingState: boolean = null;

    /**
     * Reports returned from the GSLB health check / distribution state.
     */
    @Input() public data: object;

    /**
     * Message to show to user on error or if no data is returned.
     */
    @Input() public errorMessage: string;

    /**
     * Hide copy config button.
     */
    @Input() public hideCopyConfigButton: boolean = false;

    /**
     * Internal loading indicator.
     */
    public isLoading: boolean = true;

    constructor() {
    }

    ngOnInit(): void {
        this.isLoading = this.useInternalLoadingState !== null ? this.useInternalLoadingState : true;
        // Clear loading after x seconds so the error message will show.
        if (this.isLoading) {
            const timerId = setTimeout(() => {
                this.isLoading = false;
                clearTimeout(timerId);
            }, 3000);
        }
    }

    protected readonly JSON = JSON;
}
